import { motion } from "motion/react";
import { fadeUp, inView, stagger } from "../motion";

/** Fades + slides its children up once when scrolled into view. */
export function Reveal({ as = "div", variants = fadeUp, delay = 0, className, children, ...rest }) {
  const Tag = motion[as];
  const v = delay
    ? { ...variants, show: { ...variants.show, transition: { ...variants.show.transition, delay } } }
    : variants;
  return <Tag className={className} variants={v} {...inView} {...rest}>{children}</Tag>;
}

/** Parent that staggers its motion children (children use `variants`). */
export function Stagger({ as = "div", gap = 0.08, delay = 0, amount = 0.2, className, children, ...rest }) {
  const Tag = motion[as];
  return (
    <Tag className={className} variants={stagger(gap, delay)} initial="hidden" whileInView="show"
      viewport={{ once: true, amount }} {...rest}>
      {children}
    </Tag>
  );
}
